import "firebase/compat/auth";
import "firebase/compat/database";
import moment from "moment";
import { useLocation } from "react-router-dom";

function useUrlParams() {
  const { hash } = useLocation();
  const data = hash ? hash.slice(hash.indexOf("#") + 1).split("/") : [];
  const restaurantId = data[1];
  let date = data[0];
  if (!date) date = moment().format("YYYYMMDD");

  return [restaurantId, date] as [string, string];
}

export default useUrlParams;
